import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackAdditionalDocuments = useCallback(
    (eventName: TrackingEvent, error?: any) => {
      trackEvent(
        eventName,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackAdditionalDocumentsContinue = useCallback(
    (eventName: TrackingEvent, format: string, size: string) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
        Kyc: {
          document: {
            format,
            size,
          },
        },
      });
    },
    [trackEvent],
  );

  return {
    trackAdditionalDocumentsContinue,
    trackAdditionalDocuments,
  };
};
